<template>
    <div class="invoiceList-search_wrap">
        <div class="datatable-form__header atr-header-wrap mb-4">


            <div class="invoiceList-search_item">
                <el-input v-model="searchagentname" type="text" placeholder="Agent Name"></el-input>
            </div>
            <div class="invoiceList-search_item">
                <el-input v-model="searchagentshortname" type="text" placeholder="Agent Short Name"></el-input>
            </div>

            <div class="datatable-form__submit text-center">
                <button class="btn btn-success searchbtn" id="btnSearch" v-on:click="Search('agent')">Search</button>
            </div>
        </div>
        <div class="">
            <div class="datatable-form__submit text-right">
            </div>
            <div class="pb-5">
                <el-tabs v-model="invoiceTab" type="card">
                    <el-tab-pane label="Agent List" name="first">
                        <div class="empty-list_image"
                             v-if="InvoiceListInt.length<1">
                            <strong>{{startupText}}</strong>
                            <img src="../../assets/notfound.png"/>
                        </div>
                        <div v-if="InvoiceListInt.length>0" class="datatable_group">
                            <div>
                                <el-button-group class="pull-right mb-3">
                                    <!--<el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadAsZip()">Download</el-button>-->
                                    <el-button size="small" type="primary"  v-on:click="showBModal('NewAgent')">New Agent</el-button>
                                    &nbsp;
                                    <!--<el-button size="small" type="danger"  v-on:click="showBModal('InactiveAgent')">Void</el-button>-->
                                    <!--<el-button size="small" type="primary" icon="el-icon-position" :disabled="AuditDisabled" v-if="currentSchoolID==='SCH201500000054'" v-on:click="showBModalWithBreakdown()">Send Email With Breakdown</el-button>-->
                                    <!--<el-button size="small" type="primary" icon="el-icon-position" :disabled="AuditDisabled" v-on:click="showTestBModal()">Send Batch Email (test)</el-button>-->
                                    <!--<el-button size="small" type="primary" icon="el-icon-position" :disabled="AuditDisabled" v-if="currentSchoolID==='SCH201500000054'" v-on:click="showTestBModalWithBreakdown()">Send Batch Email With Breakdown(test)</el-button>-->
                                </el-button-group>
                            </div>
                            <data-tables :data="InvoiceListInt" :action-col="InvoiceListAction"
                                         @selection-change="changeSelection" width="125"
                                         stripe tooltip-effect='light'
                                         border
                                         ref="InvoiceListTable">
                                <el-table-column type="selection" width="55" :reserve-selection="true">
                                </el-table-column>
                                <el-table-column v-for="item in InvoiceList"
                                                 :prop="item.prop"
                                                 :label="item.label"
                                                 :key="item.prop"
                                                 :hidden="!item.show"
                                                 sortable="custom"
                                                 v-if="item.show"
                                                 >
                                </el-table-column>
                            </data-tables>

                        </div>
                    </el-tab-pane>
                    <!--<el-tab-pane label="Invoice List Without Email" name="second">
                        <div class="empty-list_image"
                             v-if="InvoiceListWithoutPayeeEmailInt.length<1">
                            <strong>{{startupText}}</strong>
                            <img src="../../assets/notfound.png"/>
                        </div>
                        <div v-if="InvoiceListWithoutPayeeEmailInt.length>0" class="datatable_group">
                            <h5 class="text-left mb-3">
                                Invoice List Without Email(Please take note)
                            </h5>
                            <div>
                                <el-button-group class="pull-right mb-3">
                                    <el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadInvoiceWithoutEmailAsZip()">Download</el-button>
                                </el-button-group>
                            </div>
                            <data-tables :data="InvoiceListWithoutPayeeEmailInt"
                                         width="55" stripe tooltip-effect='light' border
                                         ref="InvoiceListWithoutPayerEmailTable">
                                <el-table-column v-for="item in InvoiceListWithoutPayeeEmail"
                                                 :prop="item.prop"
                                                 :label="item.label"
                                                 :key="item.prop"
                                                 sortable="custom">
                                </el-table-column>
                            </data-tables>
                        </div>
                    </el-tab-pane>-->
                </el-tabs>
            </div>
        </div>
        <b-modal id="showBatchEmailConfirmationModal" hide-footer title="Send Email Confirmation" size="sm"
                 ref="showBatchEmailConfirmationModal">
            <data-tables :data="selectedInvoiceListInt"
                         v-if="selectedInvoiceListInt.length>0"
                         width="55" stripe tooltip-effect='light' border
                         ref="selectedListTable">
                <el-table-column v-for="item in selectedInvoiceList"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :key="item.prop"
                                 sortable="custom">
                </el-table-column>
            </data-tables>

            <div class="invoice-modal_submitBox">
                <strong>Proceed to send email??</strong>
                <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnSendEmail('')">Yes</el-button>
                <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnSendEmail('No')">No</el-button>
            </div>
        </b-modal>

        <b-modal id="showNewAgentModal" hide-footer title="Add New Agent" size="small"
                 ref="showNewAgentModal">

            <div class="datatable-form__header atr-header-wrap mb-4">
                <div class="invoiceList-search_item"><h5 style="display:none;"> {{txtAgentID}}</h5>
                    * Agent Name: <el-input v-model="txtNewAgentName" type="text" placeholder="Agent Name"></el-input>
                </div>  
                <div class="invoiceList-search_item">
                    * Short Name: <el-input v-model="txtNewAgenShorttName" type="text" placeholder="Short Name"></el-input>
                </div>
            </div>

            <div class="invoice-modal_submitBox">
                <strong></strong>
                <el-button size="small" type="primary" v-on:click="btnSaveAgent('Yes')">Save</el-button>
                <el-button size="small" type="danger"  v-on:click="btnSaveAgent('No')">Cancel</el-button>
            </div>
        </b-modal>

        <b-modal id="showEditAgentModal" hide-footer title="Edit Agent" size="small"
                 ref="showEditAgentModal">

            <div class="datatable-form__header atr-header-wrap mb-4">
                <div class="invoiceList-search_item"><h5 style="display:none;">EDIT ID: {{txtEditAgentID}}</h5>
                    * Agent Name: <el-input v-model="txtEditAgentName" type="text" placeholder="Agent Name"></el-input>
                </div>  
                <div class="invoiceList-search_item">
                    * Short Name: <el-input v-model="txtEditAgenShorttName" type="text" placeholder="Short Name"></el-input>
                </div>
                <div class="invoiceList-search_item">
                    <el-select style="max-width: 150px" v-model="AgtStatus" clearable placeholder="Status">
                    <el-option
                            v-for="item in AgtOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select> 
                </div> 
            </div>

            <div class="invoice-modal_submitBox">
                <strong></strong>
                <el-button size="small" type="primary" v-on:click="btnUpdateAgent('Yes')">Save</el-button>
                <el-button size="small" type="danger"  v-on:click="btnUpdateAgent('No')">Cancel</el-button>
            </div>
        </b-modal>

        <b-modal id="showDeactivateagentModal" hide-footer title="Sure to Delete Agent?" size="small"
                 ref="showDeactivateagentModal">

            <div class="invoice-modal_submitBox">
                <strong></strong><h5 style="display:none;">delete ID: {{txtDeleteAgentID}}</h5>
                <el-button size="small" type="primary"  v-on:click="btnInactiveAgent('Yes')">Yes</el-button>
                <el-button size="small" type="danger"  v-on:click="btnInactiveAgent('No')">No</el-button>
            </div>
        </b-modal>

        <b-modal id="showBatchEmailConfirmationModalWithBreakdown" hide-footer
                 title="Send Email Confirmation With Breakdown" size="sm"
                 ref="showBatchEmailConfirmationModalWithBreakdown">
            <data-tables :data="selectedInvoiceListInt"
                         v-if="selectedInvoiceListInt.length>0"
                         width="55" stripe tooltip-effect='light' border
                         ref="selectedListTable">
                <el-table-column v-for="item in selectedInvoiceList"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :key="item.prop"
                                 sortable="custom">
                </el-table-column>
            </data-tables>

            <div class="invoice-modal_submitBox">
                <strong>Proceed to send email??</strong>
                <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnSendEmailWithBreakdown('')">Yes</el-button>
                <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnSendEmailWithBreakdown('No')">No</el-button>
            </div>
        </b-modal>
        <!--        //testing only: start-->
        <b-modal id="showTestingBModal" hide-footer title="Send Email Confirmation(TEST ONLY!)" size="sm"
                 ref="showTestingBModal">
            <data-tables :data="testingSelectedInvoiceListInt"
                         v-if="testingSelectedInvoiceListInt.length>0"
                         width="55" stripe tooltip-effect='light' border
                         ref="selectedListTable">
                <el-table-column v-for="item in testingSelectedInvoiceList"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :key="item.prop"
                                 sortable="custom">
                </el-table-column>
                <el-table-column label="Email(TEST)" min-width="100px">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.newTestEmail" type="text"
                                  placeholder="Email(Key in test email)"></el-input>
                    </template>
                </el-table-column>
            </data-tables>
            <div class="invoice-modal_submitBox">
                <strong>Proceed to send email??</strong>
                <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail()">Yes</el-button>
                <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail('No')">No</el-button>
            </div>
        </b-modal>
        <b-modal id="showTestingBModalWithBreakdown" hide-footer
                 title="Send Email Confirmation With Breakdown(TEST ONLY!)" size="sm"
                 ref="showTestingBModalWithBreakdown">
            <data-tables :data="testingSelectedInvoiceListInt"
                         width="55" stripe tooltip-effect='light' border
                         ref="selectedListTable">
                <el-table-column v-for="item in testingSelectedInvoiceList"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :key="item.prop"
                                 sortable="custom">
                </el-table-column>
                <el-table-column label="Email(TEST)" min-width="100px">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.newTestEmail" type="text"
                                  placeholder="Email(Key in test email)"></el-input>
                    </template>
                </el-table-column>
            </data-tables>

            <div class="invoice-modal_submitBox">
                <strong>Proceed to send email??</strong>
                <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmailWithBreakdown()">Yes</el-button>
                <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmailWithBreakdown('No')">No</el-button>
            </div>
        </b-modal>
    </div>
</template> 
<script>
    import DataSource from "../../data/datasource";
    import moment from 'moment';
    import Cookies from "js-cookie";
    import {lang} from '../../locale/index';
    import Global from "../../global";
    


    export default {
        name: "InvoiceList-Invoice",
        data() {
            return {
                startupText: '',
                inputFromDate: [],
                inputFromDueDate: [],
                studName: '',
                studNO: '',
                invName: '',

                searchagentname: '',
                searchagentshortname: '',

                txtAgentID: '0',
                txtEditAgentID: '0',
                txtDeleteAgentID: '0',

                txtNewAgentName: '',
                txtNewAgenShorttName: '',

                txtEditAgentName: '',
                txtEditAgenShorttName: '',
                AgtStatus: 'Active',

                AgtOptions: [{
                    value: 'Active',
                    label: 'Active'
                },{
                    value: 'Void',
                    label: 'Void'
                }],

                currentSchoolID: '',
               
                invoiceTab:'first',
                InvoiceListInt: [],
                InvoiceList: [{
                    prop: "Id",
                    label: "Id",
                    show: false
                }, {
                    prop: "Name",
                    label: "Name",
                    show: true
                }, {
                    prop: "ShortName",
                    label: "ShortName",
                    show: true
                }, {
                    prop: "Status",
                    label: "Status",
                    show: true
                }],
                InvoiceListAction: {
                    label: 'Action',
                    props: {
                        align: 'center',
                    },
                    buttons: 
                    [
                        {
                            props: {
                                type: 'primary',
                                icon: 'el-icon-el-date-editor',
                            },

                            handler: row => {
                                this.txtEditAgentID = row.id;
                                this.txtEditAgentName = row.Name;
                                this.txtEditAgenShorttName = row.ShortName;
                                this.AgtStatus = row.Status
                               
                                this.showBModal('EditAgentDetail');
                            },
                            label: 'Edit'
                        },
                         /*  {
                             props: {
                                 type: 'danger',
                                 icon: 'el-icon-el-date-editor',
                             },

                             handler: row => {
                                this.txtDeleteAgentID = row.id;
                                this.showBModal('InactiveAgent');
                             },
                             label: 'Void'
                        },  */
                        // {
                        //     props: {
                        //         type: 'primary',
                        //         icon: 'el-icon-el-date-editor',
                        //     },

                        //     handler: row => {
                        //         this.studentCourseID = row.PK_Student_Course_ID;
                        //         this.studentID = row.FK_Student_ID;
                        //         this.courseStatus = row.SCRS_Status;
                        //         if (this.studentCourseID) {
                        //             this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus);
                        //         } else {
                        //             this.$notify.error({
                        //                 title: 'Message',
                        //                 message: 'Error.'
                        //             });
                        //         }
                        //     },
                        //     label: 'Student List'
                        // },
                
                    ]
                },

                InvoiceListWithoutPayeeEmailInt: [],
                InvoiceListWithoutPayeeEmail: [{
                    prop: "studentName",
                    label: "Student Name"
                }, {
                    prop: "Amount",
                    label: "Amount"
                }, {
                    prop: "GstAmount",
                    label: "Gst"
                }, {
                    prop: "TotalAmountIncGst",
                    label: "TotalIncGst"
                }, {
                    prop: "OutstandingAmount",
                    label: "Outstanding Amount"
                }, {
                    prop: "IH_Invoice_Status",
                    label: "Invoice Status"
                }, {
                    prop: "IH_Invoice_No",
                    label: "Invoice Name"
                }, {
                    prop: "RH_Receipt_No",
                    label: "Receipt NO"
                }, {
                    prop: "email",
                    label: "Payee Email"
                }, {
                    prop: "sponsor_type",
                    label: "Payee"
                }, {
                    prop: "fatherEmail",
                    label: "Father Email"
                }, {
                    prop: "motherEmail",
                    label: "Mother Email"
                }],
                InvoiceListWithoutPayeeEmailAction: {
                    label: 'More info',
                    props: {
                        align: 'center',
                    },
                    buttons: [{
                        props: {
                            type: 'primary',
                            icon: 'el-icon-info'

                        },

                        handler: row => {
                            this.studentCourseID = row.PK_Student_Course_ID;
                            this.studentID = row.FK_Student_ID;
                            this.courseStatus = row.SCRS_Status;
                            if (this.studentCourseID) {
                                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus);
                            } else {
                                this.$notify.error({
                                    title: 'Message',
                                    message: 'Error.'
                                });
                            }
                        },
                        label: 'More info'
                    }]
                },
                tempResp: [],
                spdSelection: [],
                zipType: "",
                selectedInvoiceListInt: [],
                testingSelectedInvoiceListInt: [],
                testingSelectedInvoiceList: [{
                    prop: "studentName",
                    label: "Student Name"
                }, {
                    prop: "IH_Invoice_Status",
                    label: "Invoice Status"
                }, {
                    prop: "IH_Invoice_No",
                    label: "Invoice Name"
                }, {
                    prop: "email",
                    label: "Email(Key in your testing email)"
                }, {
                    prop: "sponsor_type",
                    label: "Payee"
                }, {
                    prop: "fatherEmail",
                    label: "Father Email"
                }, {
                    prop: "motherEmail",
                    label: "Mother Email"
                }],
                selectedInvoiceList: [{
                    prop: "studentName",
                    label: "Student Name"
                }, {
                    prop: "IH_Invoice_Status",
                    label: "Invoice Status"
                }, {
                    prop: "IH_Invoice_No",
                    label: "Invoice Name"
                }, {
                    prop: "email",
                    label: "Email"
                }, {
                    prop: "sponsor_type",
                    label: "Payee"
                }, {
                    prop: "fatherEmail",
                    label: "Father Email"
                }, {
                    prop: "motherEmail",
                    label: "Mother Email"
                }],
                AuditDisabled : false,
            };
        },
        mounted() {
            this.initEvent();
            //todo: for external auditor only
            let conType = Cookies.get('userTypeSession');
            if(conType==='Auditor'){
                this.AuditDisabled = true;
            }
            //todo: for external auditor only
        },
        props: ["propInvoiceListInt", "propCurrentSchoolID", "propInvoiceListWithoutPayeeEmailInt", "propZipType", "propSpdSelection"
        ,"propagentlistagentname", "propagentlistagentshortname"],
        methods: {
            async changeSelection(val) {
                this.spdSelection = val;
            },
            initEvent() {
                this.InvoiceListInt = this.propInvoiceListInt;
                this.currentSchoolID = this.propCurrentSchoolID;

                let tmpagentname = Cookies.get('agentlistagentname');
                let tmpagentshortname = Cookies.get('agentlistagentshortname');

                if (tmpagentname === "undefined")
                    { tmpagentname = "";  }
                if (tmpagentshortname === "undefined")
                    { tmpagentshortname = "";  }

                this.searchagentname = tmpagentname;
                this.searchagentshortname = tmpagentshortname;

                
                this.InvoiceListWithoutPayeeEmailInt = this.propInvoiceListWithoutPayeeEmailInt;

                this.zipType = this.propZipType;
                this.spdSelection = this.propSpdSelection;

                this.Search('agent');

            //    console.log(this.zipType);
            },
            hideModal(){
                this.$refs.showBatchEmailConfirmationModal.hide();
                this.$refs.showTestingBModalWithBreakdown.hide();
                this.$refs.showTestingBModal.hide();
                this.$refs.showBatchEmailConfirmationModalWithBreakdown.hide();
            },


            async Search(type) {
                try {

                    this.clearTablesList();
                    this.clearBModalList();

                        this.$vs.loading();

                       
                        const resp = await DataSource.shared.getAgentList(
                            this.searchagentname, this.searchagentshortname, 'list');
                        if (resp) {
                            if (resp.code === '88') {
                                window.location.replace('/');
                            } else if (resp.code === '99') {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Search Agent: Error',
                                });
                            } else if (resp.code === '2') {
                                this.$notify.error({
                                    title: 'No Record',
                                    message: 'No Agent Found',
                                });
                            } else {
                                this.InvoiceListInt = [];
                                this.tempResp = resp.Table;
                                this.tempResp.forEach(m => {
                                    this.InvoiceListInt.push(m);
                                })
                                Cookies.set('agentlistagentname', this.searchagentname, {expires: 3 / 24});
                                Cookies.set('agentlistagentshortname', this.searchagentshortname, {expires: 3 / 24});
                                
                            }
                        }
                    //}

                } catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },
            async clearTablesList() {
                this.InvoiceListInt = [];
                this.InvoiceListWithoutPayeeEmailInt = [];
            },
            async clearBModalList() {
              //  console.log("clearBModalList");
                this.spdSelection = [];
                this.selectedInvoiceListInt = [];
            },
            async downloadAsZip() {
                try {
                    let spdList = [];
                    let selectedObjList = [];
                    spdList = this.spdSelection;
                    if (this.spdSelection.length < 1) {
                        alert('Please select at least 1 item!');
                    } else {
                        this.$vs.loading();
                        spdList.forEach(m => {
                            let List = {
                                IH_Invoice_No: m.IH_Invoice_No,
                            };
                            selectedObjList.push(List);
                        });

                        const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType);
                        if (resp.code === '99') {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Cannot download files!'
                            });
                        } else {
                            let byteChar = atob(resp.code);
                            let byteNo = new Array(byteChar.length);
                            for (let i = 0; i < byteChar.length; i++) {
                                byteNo[i] = byteChar.charCodeAt(i);
                            }
                            let byteArray = new Uint8Array(byteNo);
                            let file = new Blob([byteArray], {type: 'application/zip;base64'});
                            let fileUrl = URL.createObjectURL(file);
                            window.location.href = fileUrl;
                        }
                        this.$vs.loading.close();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async downloadInvoiceWithoutEmailAsZip(){
                try {
                    let selectedObjList = [];

                        this.InvoiceListWithoutPayeeEmailInt.forEach(m => {
                            let List = {
                                IH_Invoice_No: m.IH_Invoice_No,
                            };
                            selectedObjList.push(List);
                        });
                  //  console.log("selectedObjList=",selectedObjList);
                        const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType);
                        if (resp.code === '99') {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Cannot download files!'
                            });
                        } else {
                            let byteChar = atob(resp.code);
                            let byteNo = new Array(byteChar.length);
                            for (let i = 0; i < byteChar.length; i++) {
                                byteNo[i] = byteChar.charCodeAt(i);
                            }
                            let byteArray = new Uint8Array(byteNo);
                            let file = new Blob([byteArray], {type: 'application/zip;base64'});
                            let fileUrl = URL.createObjectURL(file);
                            window.location.href = fileUrl;
                        }

                } catch (e) {
                    this.results = e;
                }
            },
            async showBModal(modaltype) {

                if (modaltype == "EditAgentDetail")
                {
                    this.$refs.showEditAgentModal.show();
                }

                if (modaltype=="NewAgent")
                {
                    this.txtNewAgenShorttName = "";
                    this.txtNewAgentName = "";
                    this.txtAgentID = "0";
                    this.$refs.showNewAgentModal.show();
                 }

                if (modaltype=="InactiveAgent")
                {
                    this.$refs.showDeactivateagentModal.show();
                    await this.getSelectedList();
                }
                        
              
            },
            async showBModalWithBreakdown() {
                try {
                    if (this.spdSelection.length < 1) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select at least 1 item!',
                        });
                    } else {
                        this.$refs.showBatchEmailConfirmationModalWithBreakdown.show();
                        await this.getSelectedList();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async getSelectedList() {
                this.selectedInvoiceListInt = this.spdSelection;
            },
            async getTestingSelectedList() {
                this.testingSelectedInvoiceListInt = this.spdSelection;
              //  console.log(this.testingSelectedInvoiceListInt,"testingSelectedInvoiceListInt")
              //  console.log(this.spdSelection,"spdSelection")
            },
            //Testing items only: start
            async showTestBModal() {
                try {
                    //todo: check if no checkbox selected
                    if (this.spdSelection.length < 1) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select at least 1 item!',
                        });
                    } else {
                        await this.getTestingSelectedList();
                        this.$refs.showTestingBModal.show();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async showTestBModalWithBreakdown() {
                try {
                    //todo: check if no checkbox selected
                    if (this.spdSelection.length < 1) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please select at least 1 item!',
                        });
                    } else {
                        this.$refs.showTestingBModalWithBreakdown.show();
                        await this.getTestingSelectedList();
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async btnSendEmail(value) {
                    this.$emit("btnSendEmail", value, this.spdSelection, "invoice");
            },
            //alexis
            async btnSaveAgent(value) {

                if (value === 'No')
                {
                    //this.$refs.invoice.hideModal();
                    this.txtNewAgenShorttName = "";
                    this.txtNewAgentName = "";
                    this.txtAgentID = "0";
                    this.txtEditAgenShorttName="";
                    this.AgtStatus="Active";
                    this.txtEditAgentName="";

                    this.$refs.showNewAgentModal.hide();
                }
                else
                {

                    if (this.txtNewAgenShorttName == "")
                    {
                        this.$notify.error({
                                        title: 'Message',
                                        message: 'Cannot Save - missing agent short name'})
                                        return;
                                        
                    }


                    if (this.txtNewAgentName == "")
                    {
                        this.$notify.error({
                                        title: 'Message',
                                        message: 'Cannot Save - missing agent name'})
                                        return;
                                        
                    }


                    this.txtAgentID = "0";
                    
                    this.$emit("btnSaveAgent", value, this.txtNewAgenShorttName, this.txtNewAgentName, this.txtAgentID, this.AgtStatus, "SaveAgentList");
                
                    this.txtNewAgenShorttName = "";
                    this.txtNewAgentName = "";
                    this.txtAgentID = "0";
                    this.txtEditAgenShorttName="";
                    this.AgtStatus="Active";
                    this.txtEditAgentName="";

                    this.$refs.showNewAgentModal.hide();
                    await this.Search('Agent');

                }

               
            },

            async btnUpdateAgent(value) {

                if (value === 'No')
                {
                    //this.$refs.invoice.hideModal();
                    this.txtEditAgentID = "0";
                    this.txtEditAgenShorttName = "";
                    this.AgtStatus="Active";
                    this.txtEditAgentName = "";
                    this.$refs.showEditAgentModal.hide();
                }
                else
                {
                    
                    this.$emit("btnSaveAgent", value, this.txtEditAgenShorttName, this.txtEditAgentName, this.txtEditAgentID, this.AgtStatus, "SaveAgentList");

                    this.txtEditAgentID = "0";
                    this.txtEditAgenShorttName = "";
                    this.AgtStatus="Active";
                    this.txtEditAgentName = "";
                    this.$refs.showEditAgentModal.hide();
                    await this.Search('Agent');

                }


                },

            async btnInactiveAgent(value) {
                if ((value == 'No'))
                {
                    this.txtDeleteAgentID = "0";
                    this.$refs.showDeactivateagentModal.hide();
                }
                else
                {
                    this.$emit("btnVoidAgent", value, this.txtDeleteAgentID, "invoice");
                    this.$refs.showDeactivateagentModal.hide();
                    await this.Search('Agent');
                }
            },

            async btnSendEmailWithBreakdown(value) {
                this.$emit("btnSendEmailWithBreakdown", value, this.spdSelection, "invoice");
            },
            async btnTestingSendEmail(value) {
                this.$emit("btnTestingSendEmail", value, this.spdSelection, "invoice");
            },
            async btnTestingSendEmailWithBreakdown(value) {
                this.$emit("btnTestingSendEmailWithBreakdown", value, this.spdSelection, "invoice");
            },
            //Testing items only: end
        }
    };
</script>
<style scoped>
</style>

<style>

    .invoice-modal_submitBox strong {
        display: block;
        margin-bottom: 10px;
    }

    .invoice-modal_submitBox {
        text-align: center;
    }
</style>